module.exports = __webpack_public_path__ + "assets/1d40184b5912fdd8eb8618d2159bc5ba.mp3";